'use client';

import { Portal, Spinner } from '@common/components';
import { useBodyScrollLock } from '@common/hooks';
import { cn } from '@core/utils';

import { getMainWrapperElement } from '@/app/_components/MainWrapperPortal';

interface LoadingPageTemplateProps {
  blur?: boolean;
  fadeIn?: boolean;
  unmountedPlaceholder?: boolean;
  className?: string;
}

export const LoadingPageTemplate = ({
  blur = false,
  fadeIn,
  unmountedPlaceholder,
  className,
}: LoadingPageTemplateProps) => {
  useBodyScrollLock(true);

  return (
    <Portal renderTo={getMainWrapperElement} placeholder={unmountedPlaceholder}>
      <div
        className={cn(
          'fixed inset-0 z-40 overflow-hidden flex-center',
          blur ? 'z-50 bg-Gray-black/60 backdrop-blur-sm' : 'bg-[#767676]',
          {
            'animate-fade animate-duration-300 animate-ease-out animate-delay-200 motion-reduce:animate-none':
              fadeIn,
          },
          className,
        )}
      >
        <Spinner logo color="white" size={80} />
      </div>
    </Portal>
  );
};
